import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import PhaseWiseNutritiveValue from "../components/PhaseWiseNutritiveValue";

const PhaseWiseNutritiveValuePage = () => {
  return (
    <>
      <Breadcrumb title="Phase Wise Nutritive Value" />
      <PhaseWiseNutritiveValue />
    </>
  );
};

export default PhaseWiseNutritiveValuePage;
